import React, {Component} from 'react';
import PropTypes from "prop-types";
import TableContainer from "../../utils/TableContainer";
import PageLinksContainer from "../../utils/PageLinksContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";

const moment = require("moment");

class HomeContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    navigate(page) {

        if (page && this.props.baseData.pageNavigation) this.props.baseData.pageNavigation(page);

        return null;

    }

    getMachineNames(machineInfos) {

        const row = [];

        for (let machineID in machineInfos) {
            let machine = machineInfos[machineID];

            row.push(
                <span key={machineID}>{machine.name} <br /></span>
            );
        }

        return row;

    }

    getMachineLocations(machineInfos) {

        const row = [];

        for (let machineID in machineInfos) {
            let machine = machineInfos[machineID];

            row.push(
                <span key={machineID}>{machine.location} <br /></span>
            );
        }

        return row;

    }

    getTriggeredAlarmColumns() {

        return [
            {
                key: 'state',
                nameKey: 'status',
            },
            {
                key: 'inserted',
                nameKey: 'triggered',
            },
            {
                key: 'machineLocations',
                nameKey: 'machineLocation',
            },
            {
                key: 'machineNames',
                nameKey: 'machineName',
            },
            {
                key: 'description',
                nameKey: 'description',
            },
            {
                key: 'type',
                nameKey: 'alarmType',
            },
            /*{
                key: 'seen',
                nameKey: 'seen',
                classes: 'text-right',
            },
            {
                key: 'confirmed',
                nameKey: 'confirmed',
                classes: 'text-right',
            },*/
        ];

    }

    getTriggeredAlarmRows() {

        const data = this.props.notifications;
        const sessionCreated = (this.props.baseData.session) ? this.props.baseData.session.dateCreated : Date.now();
        const formatedDatetime = this.timeFormats.datetime;
        const rows = [];

        if (sessionCreated) {
            for (let i = 0; i < data.length; i++) {
                let rowTemp = data[i];
                let machineInfos = rowTemp.machines;
                let machineNames = this.getMachineNames(machineInfos);
                let machineLocations = this.getMachineLocations(machineInfos);
                let state = (rowTemp.seen > sessionCreated) ? 'error' : null;

                rows.push({
                    id: rowTemp.id,
                    trClasses: state,
                    state: <i>ok</i>,
                    description: rowTemp.description,
                    type: rowTemp.type,
                    machineNames: machineNames,
                    machineLocations: machineLocations,
                    inserted: (rowTemp.date_inserted) ? moment.unix(rowTemp.date_inserted / 1000).format(formatedDatetime) : '-',
                    seen: (rowTemp.seen) ? moment.unix(rowTemp.seen / 1000).format(formatedDatetime) : '-',
                    confirmed: (rowTemp.date_confirmed) ? moment.unix(rowTemp.date_confirmed / 1000).format(formatedDatetime) : '-',
                });
            }
        }

        return rows;

    }

    getPageLinks() {

        const links = [];

        links.push(
            {
                header: 'MY.Analysis',
                classes: 'analysis',
                src: require('../../img/nav/reports-default.svg').default,
                link: 'analysis',
            },
            {
                header: 'MY.Academy',
                classes: 'academy',
                src: require('../../img/nav/sidenav/web/service-default.svg').default,
                link: 'academy',
            },
            {
                header: 'MY.Video',
                classes: 'video',
                src: require('../../img/nav/sidenav/web/videos2-default.svg').default,
                link: 'video',
            },
            {
                header: 'MY.Software',
                classes: 'software',
                src: require('../../img/nav/sidenav/web/software-default.svg').default,
                link: 'software',
            },
            {
                header: 'MY.Accessories',
                classes: 'accessories',
                src: require('../../img/nav/sidenav/web/accessories-default.svg').default,
                link: 'accessories',
            },
        );

        if (this.props.baseData.checkUserRole('translations')) {
            links.push({
                header: this.translate('translations'),
                classes: 'translations',
                src: require('../../img/nav/sidenav/web/translate-default.svg').default,
                link: 'translations',
            });
        }

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin') || this.props.baseData.checkUserRole('companyadmin')) {
            links.push({
                header: 'MY.Admin',
                classes: 'admin',
                src: require('../../img/nav/sidenav/web/accounts-default.svg').default,
                link: 'admin',
            });
        }

        return links;

    }

    getAlarmBlock() {

        const alarms = this.props.notifications;
        const alarmBlock = [];

        if (alarms.length === 0) return null;

        alarms.forEach(
            (alarm) => {
                let machineInfos = alarm.machines;
                let machineNames = this.getMachineNames(machineInfos);
                let machineLocations = this.getMachineLocations(machineInfos);

                alarmBlock.push(
                    <tr key={'alarm-' + alarm.id}>
                        <td><i>ok</i></td>
                        <td><span data-i18n={'alarmType' + alarm.type.charAt(0).toUpperCase() + alarm.type.slice(1)}>{alarm.type}</span></td>
                        <td>{machineLocations}</td>
                        <td>{machineNames}</td>
                        <td>{alarm.description}</td>
                        <td>{alarm.type}</td>
                    </tr>
                );
            }
        );

        return alarmBlock;

    }

    renderAlarms() {

        if (this.props.notifications === null) return <LoadingSplash color={'dark'}/>;
        if (this.props.notifications.length === 0) return null;

        const alarmTriggeredColumns = this.getTriggeredAlarmColumns();
        const alarmTriggeredRows = this.getTriggeredAlarmRows();

        return (
            <div className="alarmArea clearfix col-xs-12 ma-bo-10" onClick={() => this.navigate('alarms')} style={{cursor: 'pointer'}}>
                <TableContainer
                    baseData={this.props.baseData}
                    columns={alarmTriggeredColumns}
                    rows={alarmTriggeredRows}
                    maxHeight={400}
                />
            </div>
        );

    }

    render() {

        const alarmArea = this.renderAlarms();
        const pageLinks = this.getPageLinks();

        return (
            <div className="homeContainer">
                <nav>
                    <h1 data-i18n="welcomeZSKHeader">{this.translate('welcomeZSKHeader')}</h1>

                    <span className="logoBanner">
                        <img src={require('../../img/dashboard/OPC-UA- Logo.png').default} />
                    </span>
                </nav>

                {alarmArea}

                <PageLinksContainer
                    pageLinks={pageLinks}
                    pageNavigation={this.props.baseData.pageNavigation}
                />
            </div>
        );

    }

}

export default HomeContainer;